<template>
    <div>
        <modal id="modal-new-service-setup" class="skintestblock" v-model="modal" :backdrop="false" size="lg">
            <h4 slot="title" class="smalltitle">{{getTitleModal}}</h4>
            <div class="block-body">
                <div class="prolabel note">Title</div>
                <div class="profield"><input type="text" v-model="serviceItem.title"></div>
                <div class="prolabel note">Amount</div>
                <div class="profield">
                    <span class="unitwrap">
                    <input type="number" min="0" class="valueunit " unit="$" v-model="serviceItem.amount">
                    <span class="unit">$</span></span>
                </div>
                <div class="prolabel note">Billing cycle</div>
                <div class="profield">
                    <span v-for="cycle in dataBillingCycles">
                         <label class="inline-checkbox">
                        <input type="radio" name="billingevery" v-model="serviceItem.billingCycle"
                               class="yesnoselect" :value="cycle.code"> {{cycle.name}}</label> &nbsp;&nbsp;
                    </span>
                    <div class="billingevery Once_Every"
                         v-if="serviceItem.billingCycle === 'custom'">
                        <span class="unitwrap">
                            <input type="number" min="0" class="valueunit" v-model="serviceItem.billingCycleCustom">
                            <span class="unit">month</span></span>
                    </div>
                </div>
                <div class="prolabel note">Apply to</div>
                <div class="profield">
                    <label class="inline-checkbox" v-for="item in dataApplyTo">
                        <input type="radio" v-model="serviceItem.applyTo" name="billinguser"
                               class="yesnoselect" :value="item.code"> {{item.name}}
                    </label>&nbsp;&nbsp;
                    <div class="billinguser specific_members"
                         v-if="serviceItem.applyTo === 'custom'">
                        <input type="text" v-model="serviceItem.applyToCustom"
                               placeholder="Type to select members">
                    </div>
                </div>
                <div class="prolabel note">Description</div>
                <div class="profield">
                    <textarea v-model="serviceItem.description" rows="10"></textarea>
                </div>

            </div>
            <div slot="footer">
                <button type="button" class="btn btn-default" @click.prevent="saveAction()">
                    <i class="fas fa-spinner fa-spin" v-if="processing"></i>
                    <span v-if="isEdit">Save</span>
                    <span v-if="!isEdit">Create</span>
                </button>
                <button type="button" class="btn btn-default" @click.prevent="modal = false">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import axios from '../../../client'
import Common from '../../mixins/Common'

export default {
  name: 'ModalNewServiceSetup',
  mixins: [Common],
  components: {},
  props: {
    serviceEdit: {}
  },
  data () {
    return {
      modal: false,
      processing: false,
      dataBillingCycles: [
        { 'code': 'one_time_payment', 'name': 'One Time Payment' },
        { 'code': 'monthly', 'name': 'Monthly' },
        { 'code': 'yearly', 'name': 'Yearly' },
        { 'code': 'custom', 'name': 'Custom' }
      ],
      dataApplyTo: [
        { 'code': 'all', 'name': 'All' },
        { 'code': 'board_member', 'name': 'Board Member' },
        { 'code': 'general_member', 'name': 'General Member' },
        { 'code': 'custom', 'name': 'Custom' }
      ],
      serviceItem: {
        title: '',
        billingCycle: 'one_time_payment',
        applyTo: 'all',
        applyToCustom: '',
        amount: 0
      }
    }
  },
  mounted () {
    if (this.serviceEdit) {
      this.getDetail()
      return
    }
    this.modal = true
  },
  computed: {
    getTitleModal () {
      if (this.serviceEdit) {
        return 'Edit service'
      }
      return 'Create New Service'
    },
    isEdit () {
      if (this.serviceEdit) {
        return true
      }
      return false
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  methods: {
    async getDetail () {
      try {
        let response = await axios.get(`/service-setup/${this.serviceEdit._id}`)
        if (response.data.s === 200) {
          this.modal = true
          this.serviceItem = response.data.data.service
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError('Server error when get data of service.Try again ')
      }
    },
    validateForm () {
      if (!this.serviceItem.title) {
        return { s: false, msg: 'Please enter title' }
      }
      return { s: true }
    },
    async saveAction () {
      if (this.isEdit) {
        this.updateService()
        return
      }
      this.createService()
    },
    async updateService () {
      if (this.processing) {
        return
      }
      let validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        let data = this.serviceItem
        let response = await axios.put(`/service-setup/${this.serviceItem._id}`, data)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error.Try again ')
      }
    },
    async createService () {
      if (this.processing) {
        return
      }
      let validate = this.validateForm()
      if (!validate.s) {
        this.alertError(validate.msg)
        return
      }
      try {
        this.processing = true
        let data = this.serviceItem
        let response = await axios.post(`/service-setup`, data)
        this.processing = false
        if (response.data.s === 200) {
          this.$emit('createNew', {})

          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processing = false
        this.alertError('Server error.Try again ')
      }
    }
  }
}
</script>
<style scoped="">
    .expain {
        font-style: italic;
        font-size: 12px !important;
    }

    .button-remove-medication {
        margin-left: 15px;
        display: inline-block;
    }
</style>
<style>
    #modalmedicationItemInfusion .unitwrap > .unit {
        right: 5px !important;
    }
</style>
